export default __webpack_public_path__ + "static/media/community-icon.6826414b.png";